<template>
    <div>
        <h2 class="title">Ascended food crafting</h2>
        <b-message v-if="error" type="is-danger" has-icon>
            {{error}}
        </b-message>
        <b-table :data="ascendedFood" :striped="true" :narrowed="true" :loading="loading">
            <template slot-scope="props">
                <b-table-column field="stats" label="Stats" width="200">
                    <div v-bind:key="index" v-for="(stat, index) in props.row.stats">
                        {{ stat }}
                    </div>
                </b-table-column>
                <b-table-column label="66% Chance to Steal Life on Critical Hit">
                    <b-button v-if="props.row.lifeSteal" @click="showModal(props.row.lifeSteal)">
                        <currency-amount v-bind:key="index"
                                         v-for="(resourceAmount, index) in props.row.lifeSteal.inventoryDifference.filter(x => x.amount < 0 && x.resource.name === 'Coppers')"
                                         :amount="-resourceAmount.amount"
                                         :currency="resourceAmount.resource.name"
                        />
                    </b-button>
                </b-table-column>
                <b-table-column label="-10% Incoming Damage">
                    <b-button v-if="props.row.damageReduction" @click="showModal(props.row.damageReduction)">
                        <currency-amount v-bind:key="index"
                                         v-for="(resourceAmount, index) in props.row.damageReduction.inventoryDifference.filter(x => x.amount < 0 && x.resource.name === 'Coppers')"
                                         :amount="-resourceAmount.amount"
                                         :currency="resourceAmount.resource.name"
                        />
                    </b-button>
                </b-table-column>
                <b-table-column label="+10% Outgoing Healing">
                    <b-button v-if="props.row.outgoingHealing" @click="showModal(props.row.outgoingHealing)">
                        <currency-amount v-bind:key="index"
                                         v-for="(resourceAmount, index) in props.row.outgoingHealing.inventoryDifference.filter(x => x.amount < 0 && x.resource.name === 'Coppers')"
                                         :amount="-resourceAmount.amount"
                                         :currency="resourceAmount.resource.name"
                        />
                    </b-button>
                </b-table-column>
                <b-table-column label="Gain Health Every Second">
                    <b-button v-if="props.row.healthRegeneration" @click="showModal(props.row.healthRegeneration)">
                        <currency-amount v-bind:key="index"
                                         v-for="(resourceAmount, index) in props.row.healthRegeneration.inventoryDifference.filter(x => x.amount < 0 && x.resource.name === 'Coppers')"
                                         :amount="-resourceAmount.amount"
                                         :currency="resourceAmount.resource.name"
                        />
                    </b-button>
                </b-table-column>
                <b-table-column label="-20% Incoming Condition Duration"> <b-button v-if="props.row.incomingConditionDuration" @click="showModal(props.row.incomingConditionDuration)">
                    <currency-amount v-bind:key="index"
                                     v-for="(resourceAmount, index) in props.row.incomingConditionDuration.inventoryDifference.filter(x => x.amount < 0 && x.resource.name === 'Coppers')"
                                     :amount="-resourceAmount.amount"
                                     :currency="resourceAmount.resource.name"
                    />
                </b-button>
                </b-table-column>
            </template>
        </b-table>
        <b-modal :active.sync="modalShown"
                 :width="1200">
            <div class="modal-card" style="width: auto" v-if="modalFood">
                <header class="modal-card-head">
                    <p class="modal-card-title">Food crafting</p>
                </header>
                <section class="modal-card-body">
                    <AcquisitionCard :acquisition="modalFood"/>
                </section>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios";
    import AcquisitionCard from "@/components/AcquisitionCard";
    import CurrencyAmount from "@/components/CurrencyAmount";

    export default {
        name: 'calculators-ascended-food',
        components: {AcquisitionCard, CurrencyAmount},
        data() {
            return {
                ascendedFood: [],
                loading: false,
                modalShown: false,
                modalFood: null,
                error: null,
            }
        },
        methods: {
            loadAsyncData() {
                this.loading = true;
                axios.get("/calculators/ascended-food").then(response => {
                    this.ascendedFood = response.data;
                    this.error = "";
                }).catch(error => {
                    this.ascendedFood = [];
                    this.error = error;
                }).finally(() => {
                    this.loading = false;
                })
            },
            showModal(food) {
                this.modalFood = food;
                this.modalShown = true;
            },
        },
        mounted() {
            this.loadAsyncData();
        }
    }
</script>

<style>
</style>
